import React, { createContext, useContext, useState } from 'react';

interface TicketRefreshContextType {
  refreshTrigger: number;
  triggerRefresh: () => void;
}

const TicketRefreshContext = createContext<TicketRefreshContextType | undefined>(undefined);

export const TicketRefreshProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // Using a number as a trigger - incrementing it will cause components to re-render
  const [refreshTrigger, setRefreshTrigger] = useState<number>(0);

  const triggerRefresh = () => {
    // Increment the counter to trigger a refresh
    setRefreshTrigger(prev => prev + 1);
  };

  const value = {
    refreshTrigger,
    triggerRefresh
  };

  return (
    <TicketRefreshContext.Provider value={value}>
      {children}
    </TicketRefreshContext.Provider>
  );
};

export const useTicketRefresh = () => {
  const context = useContext(TicketRefreshContext);
  if (context === undefined) {
    throw new Error('useTicketRefresh must be used within a TicketRefreshProvider');
  }
  return context;
};
